import { defineGlobalStyles } from '@chakra-ui/react';

/**
 * Global styles for the Chakra theme
 *
 * These styles mirror the base reset and typography from the legacy Theme.tsx
 * GlobalStyles component. Third-party library styling (flatpickr, react-toggle)
 * is kept in Theme.tsx until those components are migrated to Chakra equivalents.
 */
export const globalStyles = defineGlobalStyles({
  html: {
    height: '100%',
    colorScheme: 'dark',
  },

  ':root': {
    colorScheme: 'dark',
  },

  '*, *::before, *::after': {
    boxSizing: 'border-box',
  },

  '::selection': {
    backgroundColor: '#46acb9',
    color: '#121212',
  },

  '*::-webkit-scrollbar-thumb': {
    backgroundColor: 'scrollBar',
    border: '4px solid transparent',
    borderRadius: '8px',
    backgroundClip: 'padding-box',
  },

  '*::-webkit-scrollbar': {
    width: '15px',
    borderLeft: '1px solid',
    borderLeftColor: 'separator',
  },

  img: {
    textIndent: '-9999px',
  },

  body: {
    backgroundColor: 'background',
    color: 'text',
    height: '100%',
    padding: 0,
    margin: 0,
  },

  'body, h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4': {
    fontFamily: "'Nunito Sans', sans-serif",
    fontWeight: 100,
    color: 'text',
    letterSpacing: '-0.02em',
    fontSize: 'calc(12px + (16 - 12) * ((100vw - 300px) / (1600 - 300)))',
    lineHeight: 'calc(1.3em + (1.5 - 1.2) * ((100vw - 300px) / (1600 - 300)))',
  },

  'h1, h2, h3, h4, h5, h6, p': {
    margin: 0,
    padding: 0,
  },

  'div, p': {
    fontSize: 'calc(12px + (2) * ((100vw - 300px) / (1600 - 300)))',
    lineHeight: 'calc(1.3em + (0.3) * ((100vw - 300px) / (1600 - 300)))',
  },

  h1: {
    fontSize: 'calc(22px + (34 - 24) * ((100vw - 300px) / (1600 - 300)))',
    lineHeight: 'calc(1.3em + (1.5 - 1.2) * ((100vw - 300px) / (1600 - 300)))',
    fontWeight: 100,
  },

  'h3, h4': {
    fontSize: 'calc(18px + (30 - 20) * ((100vw - 300px) / (1600 - 300)))',
    lineHeight: 'calc(1.3em + (1.5 - 1.2) * ((100vw - 300px) / (1600 - 300)))',
    fontWeight: 100,
  },

  h5: {
    fontSize: 'calc(14px + (30 - 20) * ((100vw - 300px) / (1600 - 300)))',
    lineHeight: 'calc(1.3em + (1.5 - 1.2) * ((100vw - 300px) / (1600 - 300)))',
    fontWeight: 100,
  },

  h6: {
    fontSize: 'calc(12px + (30 - 20) * ((100vw - 300px) / (1600 - 300)))',
    lineHeight: 'calc(1.3em + (1.5 - 1.2) * ((100vw - 300px) / (1600 - 300)))',
    fontWeight: 100,
  },

  i: {
    fontSize: 'calc(50px + (10) * ((100vw - 300px) / (1600 - 300)))',
  },

  a: {
    textDecoration: 'none',
    color: 'inherit',
  },

  '#mount': {
    height: '100%',
  },

  'textarea, textarea::placeholder': {
    fontFamily: "'Nunito Sans', sans-serif",
  },

  'table, th, td, tr': {
    fontFamily: "'Nunito Sans', sans-serif",
    fontWeight: 100,
  },

  hr: {
    height: '1px',
    border: 'none',
    backgroundColor: 'separator',
  },

  '.menu-item-wrapper:focus': {
    outline: 'none',
  },

  '.export-pdf': {
    backgroundColor: 'background',
  },
});
